import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateInboundSmsRules as UpdateInboundSmsRulesMutation,
    UpdateInboundSmsRulesVariables as UpdateInboundSmsRulesMutationVariables,
    InboundSmsRulesUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_INBOUND_SMS_RULES from '../mutations/update-inbound-sms-rules.graphql';

export const useUpdateInboundSmsRules = (): {
    updateInboundSmsRules: (input: InboundSmsRulesUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateInboundSmsRules, {loading, error}] = useMutation<
        UpdateInboundSmsRulesMutation,
        UpdateInboundSmsRulesMutationVariables
    >(UPDATE_INBOUND_SMS_RULES);

    return {
        updateInboundSmsRules: (input: InboundSmsRulesUpdateInput) => {
            return updateInboundSmsRules({variables: {input}});
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
